"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
exports.__esModule = true;
exports.TextField = void 0;
var react_1 = __importDefault(require("react"));
var Icon_1 = require("@kaizen/component-library/components/Icon");
var success_icon_svg_1 = __importDefault(require("@kaizen/component-library/icons/success.icon.svg"));
var classnames_1 = __importDefault(require("classnames"));
var __1 = require("..");
var styles_scss_1 = __importDefault(require("./styles.scss"));
var TextField = function (_a) {
    var _b, _c, _d, _e;
    var id = _a.id, inputType = _a.inputType, _f = _a.disabled, disabled = _f === void 0 ? false : _f, labelText = _a.labelText, inputValue = _a.inputValue, defaultInputValue = _a.defaultInputValue, inputRef = _a.inputRef, validationMessage = _a.validationMessage, description = _a.description, _g = _a.reversed, reversed = _g === void 0 ? false : _g, _h = _a.inline, inline = _h === void 0 ? false : _h, status = _a.status, icon = _a.icon, inputProps = __rest(_a, ["id", "inputType", "disabled", "labelText", "inputValue", "defaultInputValue", "inputRef", "validationMessage", "description", "reversed", "inline", "status", "icon"]);
    var validationMessageAria = validationMessage
        ? "".concat(id, "-field-validation-message")
        : "";
    var descriptionAria = description ? "".concat(id, "-field-description") : "";
    var ariaDescribedBy = [validationMessageAria, descriptionAria].reduce(function (prev, curr) { return (curr ? [curr, prev].join(" ") : prev); }, "");
    return (react_1["default"].createElement(__1.FieldGroup, { id: "".concat(id, "-field-group"), automationId: "".concat(id, "-field-group"), inline: inline, className: (0, classnames_1["default"])(styles_scss_1["default"].withLabel, (_b = {},
            _b[styles_scss_1["default"].withDisabled] = disabled,
            _b)) },
        react_1["default"].createElement(__1.Label, { id: "".concat(id, "-field-label"), automationId: "".concat(id, "-field-label"), htmlFor: "".concat(id, "-field-input"), labelText: labelText, reversed: reversed, disabled: disabled }),
        react_1["default"].createElement(__1.Input, __assign({ id: "".concat(id, "-field-input"), automationId: "".concat(id, "-field-input"), ariaDescribedBy: ariaDescribedBy, inputType: inputType, inputValue: inputValue, defaultInputValue: defaultInputValue, inputRef: inputRef, disabled: disabled, reversed: reversed, status: status, startIconAdornment: icon && (react_1["default"].createElement("div", { className: styles_scss_1["default"].icon },
                react_1["default"].createElement(Icon_1.Icon, { icon: icon, role: "presentation" }))), endIconAdornment: status === "success" && (react_1["default"].createElement("div", { className: (0, classnames_1["default"])(styles_scss_1["default"].success, (_c = {},
                    _c[styles_scss_1["default"].disabled] = disabled,
                    _c)) },
                react_1["default"].createElement(Icon_1.Icon, { icon: success_icon_svg_1["default"], role: "presentation" }))) }, inputProps)),
        validationMessage && (react_1["default"].createElement("div", { className: (0, classnames_1["default"])(styles_scss_1["default"].message, (_d = {},
                _d[styles_scss_1["default"].disabled] = disabled,
                _d)) },
            react_1["default"].createElement(__1.FieldMessage, { id: "".concat(id, "-field-message"), automationId: "".concat(id, "-field-validation-message"), message: validationMessage, status: status, reversed: reversed }))),
        description && (react_1["default"].createElement("div", { className: (0, classnames_1["default"])(styles_scss_1["default"].message, (_e = {},
                _e[styles_scss_1["default"].disabled] = disabled,
                _e)) },
            react_1["default"].createElement(__1.FieldMessage, { id: "".concat(id, "-field-message"), automationId: "".concat(id, "-field-description"), message: description, reversed: reversed })))));
};
exports.TextField = TextField;
//# sourceMappingURL=TextField.js.map